/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	AcademicUser,
	AcademicUserFromJSON,
	AcademicUserFromJSONTyped,
	AcademicUserToJSON,
} from "./AcademicUser";
import {
	Department,
	DepartmentFromJSON,
	DepartmentFromJSONTyped,
	DepartmentToJSON,
} from "./Department";
import {
	Faculty,
	FacultyFromJSON,
	FacultyFromJSONTyped,
	FacultyToJSON,
} from "./Faculty";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";
import {
	StudyProgram,
	StudyProgramFromJSON,
	StudyProgramFromJSONTyped,
	StudyProgramToJSON,
} from "./StudyProgram";

/**
 *
 * @export
 * @interface Announcement
 */
export interface Announcement {
	/**
	 *
	 * @type {string}
	 * @memberof Announcement
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof Announcement
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof Announcement
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof Announcement
	 */
	publisherId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof Announcement
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof Announcement
	 */
	description?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof Announcement
	 */
	validFrom?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof Announcement
	 */
	validTo?: Date;
	/**
	 *
	 * @type {Role}
	 * @memberof Announcement
	 */
	recipientRole?: Role;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof Announcement
	 */
	years?: Array<StudentYearEnum> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof Announcement
	 */
	studyCycles?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof Announcement
	 */
	targetCompanyIds?: Array<string> | null;
	/**
	 *
	 * @type {AcademicUser}
	 * @memberof Announcement
	 */
	publisher?: AcademicUser;
	/**
	 *
	 * @type {Array<Faculty>}
	 * @memberof Announcement
	 */
	faculties?: Array<Faculty> | null;
	/**
	 *
	 * @type {Array<Department>}
	 * @memberof Announcement
	 */
	departments?: Array<Department> | null;
	/**
	 *
	 * @type {Array<StudyProgram>}
	 * @memberof Announcement
	 */
	studyPrograms?: Array<StudyProgram> | null;
}

export function AnnouncementFromJSON(json: any): Announcement {
	return AnnouncementFromJSONTyped(json, false);
}

export function AnnouncementFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): Announcement {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		publisherId: !exists(json, "publisherId") ? undefined : json["publisherId"],
		title: !exists(json, "title") ? undefined : json["title"],
		description: !exists(json, "description") ? undefined : json["description"],
		validFrom: !exists(json, "validFrom")
			? undefined
			: new Date(json["validFrom"]),
		validTo: !exists(json, "validTo") ? undefined : new Date(json["validTo"]),
		recipientRole: !exists(json, "recipientRole")
			? undefined
			: RoleFromJSON(json["recipientRole"]),
		years: !exists(json, "years")
			? undefined
			: json["years"] === null
			? null
			: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		studyCycles: !exists(json, "studyCycles") ? undefined : json["studyCycles"],
		targetCompanyIds: !exists(json, "targetCompanyIds")
			? undefined
			: json["targetCompanyIds"],
		publisher: !exists(json, "publisher")
			? undefined
			: AcademicUserFromJSON(json["publisher"]),
		faculties: !exists(json, "faculties")
			? undefined
			: json["faculties"] === null
			? null
			: (json["faculties"] as Array<any>).map(FacultyFromJSON),
		departments: !exists(json, "departments")
			? undefined
			: json["departments"] === null
			? null
			: (json["departments"] as Array<any>).map(DepartmentFromJSON),
		studyPrograms: !exists(json, "studyPrograms")
			? undefined
			: json["studyPrograms"] === null
			? null
			: (json["studyPrograms"] as Array<any>).map(StudyProgramFromJSON),
	};
}

export function AnnouncementToJSON(value?: Announcement | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		publisherId: value.publisherId,
		title: value.title,
		description: value.description,
		validFrom:
			value.validFrom === undefined ? undefined : value.validFrom.toISOString(),
		validTo:
			value.validTo === undefined ? undefined : value.validTo.toISOString(),
		recipientRole: RoleToJSON(value.recipientRole),
		years:
			value.years === undefined
				? undefined
				: value.years === null
				? null
				: (value.years as Array<any>).map(StudentYearEnumToJSON),
		studyCycles: value.studyCycles,
		targetCompanyIds: value.targetCompanyIds,
		publisher: AcademicUserToJSON(value.publisher),
		faculties:
			value.faculties === undefined
				? undefined
				: value.faculties === null
				? null
				: (value.faculties as Array<any>).map(FacultyToJSON),
		departments:
			value.departments === undefined
				? undefined
				: value.departments === null
				? null
				: (value.departments as Array<any>).map(DepartmentToJSON),
		studyPrograms:
			value.studyPrograms === undefined
				? undefined
				: value.studyPrograms === null
				? null
				: (value.studyPrograms as Array<any>).map(StudyProgramToJSON),
	};
}
